import { JSX, forwardRef } from "react";

import MovieCard, { MovieCardProps } from "./MovieCard";
import "./styles.css";

const RecMovieCard = forwardRef<HTMLImageElement, MovieCardProps>((props): JSX.Element => {
  return (
    <div className="relative flex h-[11.4375rem] w-[24.375rem] items-center justify-end max-lg:h-[8rem] max-lg:w-[19rem]">
      <span className="border-gradient-text pointer-events-none absolute left-[0.9rem] text-[11.25rem] font-black max-lg:text-[8rem]">
        {props.index + 1}
      </span>
      <div className="h-[10.625rem] w-[18.75rem] drop-shadow-[0_0_1rem_#FF4B0050] max-lg:h-[8rem] max-lg:w-[15rem]">
        <MovieCard {...props} />
      </div>
    </div>
  );
});

export default RecMovieCard;
